import { Helmet } from "react-helmet";

const HouseInsurance = () =>{
    return (
      <>
      <Helmet>
        <title>Cheap house insaurance</title>
      </Helmet>
        <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
          {/* =================== Sticky section ================= */}
          <section>
            <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
              <h2 className="text-xl font-bold text-white text-center">
                Get Project Estimation
              </h2>
              <form className="mt-6 lg:mt-3">
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                  type="text"
                  placeholder="Name"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                  type="email"
                  placeholder="Email"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                  type="number"
                  placeholder="Phone number"
                />
                <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                  <option disabled="" selected="">
                    Select Budget
                  </option>
                  <option>USD 2000 - USD 5000</option>
                  <option>USD 5000 - USD 10000</option>
                  <option>USD 10000 - USD 20000</option>
                  <option>USD 20000 - USD 40000</option>
                  <option>USD 40000 - USD 60000</option>
                  <option>USD 60000 - USD 90000</option>
                  <option>USD 90000 - USD 130000</option>
                  <option>USD 130000 - USD 200000</option>
                  &gt;
                </select>
                <textarea
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                  placeholder="message"
                  rows={3}
                  defaultValue={""}
                />
                <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                  Submit
                </button>
              </form>
            </div>
          </section>
          {/* ================= Main section =================== */}
          <section>
            {/* ====================================
                          Hero section
          ===================================== */}
            <section className="mt-8 mb-16 lg:mb-32">
              <div
                style={{ backgroundImage: 'url("image/house-insurance.jpg")' }}
                className="bg-no-repeat h-[80vh] rounded-lg flex flex-col items-center justify-center bg-black bg-blend-overlay bg-opacity-30 bg-center"
              >
                <h1 className="text-5xl font-black leading-[1.3] text-white max-w-2xl text-center ">
                  COMPARE HOME INSURANCE QUOTES AND YOU COULD SAVE MONEY
                </h1>
                <p className="lg:w-[500px] text-white mt-4 text-center">
                  We've teamed up with top insurers to deliver affordable life insurance
                  meant to protect your beneficiaries from financial hardship.
                </p>
                <a
                  href="#text"
                  className="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-blue rounded-xl group mt-5"
                >
                  <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-[#297dc2] rounded group-hover:-mr-4 group-hover:-mt-4">
                    <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white" />
                  </span>
                  <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-[#2e8ddb] rounded-2xl group-hover:mb-12 group-hover:translate-x-0" />
                  <span className="relative w-full text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">
                    Button Text
                  </span>
                </a>
              </div>
            </section>
            {/* ====================================
                          Text section
          ===================================== */}
            <section className={-32}>
              <div className="text-lg font-medium text-gray-700 text-justify">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                  What is Home Insurance?
                </h2>
                <p className="my-6">
                  Owning a home may be your biggest investment, so how can you protect
                  it? Well, home insurance is a form of property insurance that you can
                  purchase to protect your property and your belongings. It may not be
                  something we think about every day, but unexpected incidents can
                  happen at any time to your home, which is why home insurance is
                  important to have. But home insurance wasn’t always an option for
                  people. Did you know that home insurance originated from something
                  called "fire insurance?" As the name suggests, fire insurance was used
                  to cover fires, but has since evolved to "home insurance" since it now
                  covers more than just that. Like what, you may ask? Well, let's talk
                  about it. We have answers to some questions you may be wondering
                  about.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                  Do I need home Insurance?
                </h2>
                <p className="my-6">
                  Before we get into the nitty-gritty of all your home insurance
                  questions, let's start off by saying we strongly recommend that you
                  have home insurance, simply for all the value it offers — even if home
                  insurance isn't mandated by law the same way that car insurance is.
                  Keep in mind that if you're looking to purchase a home, or if you're a
                  homeowner that has applied for a mortgage, your lender will likely
                  require you to purchase home insurance first anyways. Having home
                  insurance can protect you from having to pay a large lump sum to
                  repair damages to your property and personal belongings if something
                  happens to or in your home. So, although home insurance isn’t
                  necessarily a requirement, it definitely plays a crucial role in
                  protecting what may be your greatest asset in Dubai, UAE, United Arab
                  Emirates, Abu Dhabi, Sharjah, Al Ain, Ajman, Ras Al Khaimah, Fujairah,
                  or Umm Al Quwain.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                  What does home insurance cover?
                </h2>
                <p className="my-6">
                  Home insurance covers expenses that occur when something unexpected or
                  accidental happens to your home and/or your belongings. That means
                  that you'll receive financial protection against losses due to theft,
                  fire, wind damage and much more. Should anything happen to your home,
                  your standard policy can include coverage for the structure of your
                  home, coverage for your personal belongings, and coverage for
                  additional living expenses (if you're unable to live in your home
                  while it's being repaired due to a covered loss). Home insurance also
                  covers more than just your home. It can also come to the rescue if
                  someone injures themselves on your property, or if you damage someone
                  else's property or accidentally injure someone. This is where your
                  liability protection will kick in which is also typically included in
                  a standard policy. These policies can cover incidents that involve
                  pets as well. <br />
                  <br />
                  Let’s take a look at a couple of examples of what you’re generally
                  covered for. Let's say you become a victim to theft and some of your
                  big-ticket personal belongings are stolen. Depending on how your
                  policy is set up, your home insurance will provide you with coverage
                  based on either the Replacement Cost or the Actual Cash Value of your
                  stolen items (subject to your deductible, of course). Or, let's say
                  you experience a loss due to fire — your home insurance will cover the
                  repair, the reconstruction or the replacement of your home, depending
                  on the extent of the damages and your coverage limits.
                </p>
                <h3 className="font-bold text-2xl my-6">
                  Are there different types of home insurance?
                </h3>
                <p>
                  TAlthough different insurers may have different names for their
                  coverages, here are a couple of types/tiers of home insurance to
                  consider:
                </p>
                <ul className="list-decimal ps-5 leading-10 mt-4">
                  <li>
                    Comprehensive form: This is the highest tier of home insurance and
                    the most common of the three. Comprehensive (also referred to as
                    "all risk") coverage covers your home and belongings from all loss,
                    with the exception of some exclusions which will be directly listed
                    on your policy.
                  </li>
                  <li>
                    {" "}
                    Broad form: This is the mid-tier level of home insurance which
                    provides more extensive coverage on bigger items such as the
                    building itself and will provide basic coverage on other items that
                    are specified on your policy.
                  </li>
                  <li>
                    Basic form: This is the simplest level of insurance coverage
                    offered, in which only certain items listed on your policy are
                    covered and is usually suitable for those with seasonal cottages or
                    camps. This option is cheaper than the two listed above; however,
                    you do carry more financial risk should anything happen to your
                    home.
                  </li>
                </ul>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-12">
                <h3 className="text-3xl md:text-4xl text-start font-bold text-black">
                  What's not covered under home insurance?
                </h3>
                <p className="my-6">
                  While coverage varies from policy to policy, it’s hard to determine
                  the exact extent of what may not be covered. With TD Insurance, our
                  home insurance offerings all follow comprehensive form/all risk
                  coverage, meaning that all risks are covered, with the exception of
                  specific properties and exclusions outlined in your policy. Regardless
                  of who your insurer is, check your policy carefully to understand
                  these exclusions. Should you find something you'd like/need coverage
                  for that's listed as an exclusion on your policy, you can always check
                  to see whether there is an option to buy additional coverage for it
                  through an add-on. If in doubt, talk to your insurance provider to get
                  the information you need. <br />
                  <br />
                  Keep in mind that some exclusions are outright, meaning that there are
                  no options to add on coverage to include them in your policy. In these
                  cases, you would be responsible for covering these losses yourself.
                  These exclusions are common to most insurance companies and typically
                  include wear and tear, damage caused by pests (such as rodents or
                  insects) and acts of terrorism, to name a few. <br />
                  <br />
                  Your policy is also likely to contain specific dollar limits and
                  possible coverage restrictions on certain categories of items, such as
                  jewellery or wine collections. If you have belongings of particularly
                  high-value, you should check these limits and restrictions to ensure
                  you're properly covered. Should you need additional coverage, check
                  out our Personal Valuables Coverage to learn more.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-12">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                  How do I choose the right coverage for me?
                </h2>
                <p className="my-6">
                  It can be difficult to find the best coverage that fits your needs,
                  especially since there is no one solution that fits all. At TD
                  Insurance, we're here to help you find the coverage that's right for
                  you. We offer fully customizable packages that allow you to add extra
                  coverages, ensuring your policy meets all your unique needs. Some
                  examples of our add-on coverages include: earthquake, identity theft
                  and damage due to water entering your home from the outside.
                </p>
              </div>
            </section>
          </section>
        </main>
      </>
    )
}

export default HouseInsurance;